module.exports = __webpack_public_path__ + "img/icon_team_blue.b71e8d6d.png";